import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputAdderComponent } from './input-adder/input-adder.component';


@NgModule({
  declarations: [InputAdderComponent],
  imports: [
    CommonModule
  ],
  exports: [InputAdderComponent]
})
export class InputAdderModule {
}
